import { useEffect, useState } from 'react';
import axios from 'axios';
import { PageShell } from '../components/PageShell';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AboutPage = () => {
  const [page, setPage] = useState(null);
  useEffect(() => {
    axios.get(`${API}/pages/about`).then(r => setPage(r.data)).catch(() => {});
  }, []);

  return (
    <PageShell>
      <section className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <p className="font-heading text-[10px] tracking-[0.4em] uppercase text-primary-main/80 mb-3">Our Story</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
          {page?.title || 'About RDPT Plus'}
        </h1>
        {page?.subtitle && <p className="mt-3 font-body text-lg text-white/60 italic">{page.subtitle}</p>}

        {page?.image_url && (
          <div className="mt-10 rounded-2xl overflow-hidden border border-white/[0.06]">
            <img src={page.image_url} alt={page.title} className="w-full block" />
          </div>
        )}

        <div className="mt-10">
          {page?.body ? (
            <div
              className="font-body text-base text-white/75 leading-relaxed whitespace-pre-wrap"
              data-testid="about-body"
            >{page.body}</div>
          ) : (
            <div className="font-body text-base text-white/40 italic">
              Content coming soon — admins can edit this page from the dashboard.
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
};

export default AboutPage;
